var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupthumb = function SvgGroupthumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.523 3.559V2.5M7.757 7.794H6.698M18.346 7.794h-1.059M9.346 4.618l-.749-.75M15.699 4.618l.749-.75M9.25 12.387V20.5M14.669 12.387h2.247a2.13 2.13 0 0 1 2.08 2.587l-.848 3.854a2.13 2.13 0 0 1-2.08 1.672M16.068 20.5h-9.8a1.065 1.065 0 0 1-1.065-1.065v-5.984c0-.588.477-1.065 1.065-1.065H9.26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.669 12.387V9.43a1.42 1.42 0 0 0-.785-1.27l-.36-.18a1.775 1.775 0 0 0-2.366.767L9.26 12.387"
  })));
};
export { SvgGroupthumb as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDA5YjEzMGQ4NGQyYmQ3NzE2ZWM3ZTE0ZDA5YjM0MDEuc3ZnIjs=";